<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{ title }}</h1>
      <div class="row">
        <div class="col-xs-12">
          <list
            ref="vuetable"
            :show-empty="true"
            :title="'Listagem de ' + title"
            reportTitle="Dados"
            api-url="dado/list"
            :fields="model.columns"
            :initial-page="pagina"
            :pageCollection="'dados'"
            :appendParams="filtros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-4">
                  <label class="custom-font" for="nome_filter">Nome</label>
                  <input
                    type="text"
                    v-model="nome"
                    class="form-control"
                    name="nome_filter"
                  />
                </div>
                <div class="col-sm-4">
                  <label class="custom-font" for="periodicidade_codigo_filter"
                    >Periodicidade</label
                  >

                  <select
                    v-model="periodicidade_codigo"
                    @change="consultar"
                    name="periodicidade_codigo_filter"
                    class="form-control select-selected"
                  >
                    <option value="*">Todas</option>
                    <option
                      v-for="i in periodicidades"
                      :key="i.codigo"
                      :value="i.codigo"
                    >
                      {{ i.descricao }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <label class="custom-font" for="DAD_DLFONTE_filter"
                    >Fonte</label
                  >
                  <input
                    type="text"
                    v-model="fonte"
                    name="DAD_DLFONTE_filter"
                    class="form-control"
                  />
                </div>
                <div class="col-sm-4">
                  <label class="custom-font" for="secretaria_sigla_filter"
                    >Secretaria</label
                  >
                  <select
                    v-model="secretaria_sigla"
                    @change="consultar"
                    name="secretaria_sigla_filter"
                    class="form-control select-selected"
                  >
                    <option value="">Todas</option>
                    <option
                      v-for="i in secretarias"
                      :key="i.codigo"
                      :value="i.sigla"
                    >
                      {{ i.sigla }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <label class="custom-font" for="autarquia_sigla_filter"
                    >Autarquia</label
                  >
                  <select
                    v-model="autarquia_sigla"
                    @change="consultar"
                    name="autarquia_sigla_filter"
                    class="form-control select-selected"
                  >
                    <option value="">Todas</option>
                    <option
                      v-for="i in autarquias"
                      :key="i.codigo"
                      :value="i.sigla"
                    >
                      {{ i.sigla }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <label class="custom-font" for="status_values_filter"
                    >Status de Preenchimento</label
                  >
                  <select
                    v-model="status_values"
                    @change="consultar"
                    name="status_values_filter"
                    class="form-control select-selected"
                  >
                    <option value="*">Todos</option>
                    <option value="completo">Completo</option>
                    <option value="pendente_ultimoano">
                      Ultimo ano pendente
                    </option>
                    <option value="pendente_anos_anteriores">
                      Anos anteriores pendente
                    </option>
                    <option value="nenhum">Sem lançamentos</option>
                  </select>
                </div>
                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                class="btn btn-default"
                :to="{ name: 'admin_dado_save' }"
              >
                <font-awesome-icon :icon="'plus'"></font-awesome-icon>
                Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="ano1" slot-scope="props">
              <div class="">
                <span>
                  <font-awesome-icon
                    v-if="props.rowData.hasValorAno1"
                    :icon="'check'"
                    style="color: green"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-else
                    :icon="'minus'"
                    style="color: red"
                  ></font-awesome-icon>
                </span>
              </div>
            </template>
            <template slot="ano2" slot-scope="props">
              <div class="">
                <span>
                  <font-awesome-icon
                    v-if="props.rowData.hasValorAno2"
                    :icon="'check'"
                    style="color: green"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-else
                    :icon="'minus'"
                    style="color: red"
                  ></font-awesome-icon>
                </span>
              </div>
            </template>
            <template slot="ano3" slot-scope="props">
              <div class="">
                <span>
                  <font-awesome-icon
                    v-if="props.rowData.hasValorAno3"
                    :icon="'check'"
                    style="color: green"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-else
                    :icon="'minus'"
                    style="color: red"
                  ></font-awesome-icon>
                </span>
              </div>
            </template>
            <template slot="ano4" slot-scope="props">
              <div class="">
                <span>
                  <font-awesome-icon
                    v-if="props.rowData.hasValorAno4"
                    :icon="'check'"
                    style="color: green"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-else
                    :icon="'minus'"
                    style="color: red"
                  ></font-awesome-icon>
                </span>
              </div>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="button-wrapper">
                <button
                  title="Listar valores"
                  type="button"
                  class="btn btn-primary"
                  @click="listValues(props.rowData)"
                >
                  <font-awesome-icon :icon="'list-ol'"></font-awesome-icon>
                </button>
                <button
                  title="Editar"
                  type="button"
                  class="btn btn-primary"
                  @click="editar(props.rowData)"
                >
                  <font-awesome-icon :icon="'edit'"></font-awesome-icon>
                </button>
                <button
                  title="Excluir"
                  class="btn btn-danger"
                  @click="excluir(props.rowData)"
                >
                  <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}

.button-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: right;
  min-width: 145px;
}
.button-wrapper > button {
  margin-left: 4px;
}

.button-wrapper > button:first-child {
  margin-left: 0px;
}
</style>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  inject: ['showConfirm'],
  name: 'dados',
  data() {
    return {
      title: 'Dados',
      type: 'DADO',
      periodicidades: [],
      secretarias: [],
      autarquias: [],
      model: {
        columnID: 'codigo',
        columns: [
          {
            name: 'nome',
            title: 'Nome',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: '__slot:icon1',
            columnName: 'valorAno1',
            title: this.titleAnos().ano1,
            titleClass: 'text-center',
            dataClass: 'align-middle text-center'
          },
          {
            name: '__slot:icon2',
            columnName: 'valorAno2',
            title: this.titleAnos().ano2,
            titleClass: 'text-center',
            dataClass: 'align-middle text-center'
          },
          {
            name: '__slot:icon3',
            columnName: 'valorAno3',
            title: this.titleAnos().ano3,
            titleClass: 'text-center',
            dataClass: 'align-middle text-center'
          },
          {
            name: '__slot:icon4',
            columnName: 'valorAno4',
            title: this.titleAnos().ano4,
            titleClass: 'text-center',
            dataClass: 'align-middle text-center'
          },
          {
            name: 'periodicidade',
            title: 'Periodicidade',
            dataClass: 'align-middle col-md-1 text-center',
            filterable: true
          },
          {
            name: 'fonte',
            title: 'Fonte',
            dataClass: 'truncate-text-70',
            filterable: true,
            callback: value =>
              `<span style="cursor:default" title="${value}">${value}</span>`
          },
          {
            name: '__slot:actions',
            title: 'Ações',
            titleClass: 'text-center col-md-2',
            dataClass: 'text-center'
          }
        ]
      }
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    request
      .get('listar-periodicidades')
      .then(response => {
        if (response.status) {
          this.periodicidades = response.data.data
        }
      })
      .catch(e => {
        console.log(e)
        this.$toastr.e(
          'Houve uma falha ao tentar carregar o filtro periodicidades!'
        )
      })

    request
      .get('listar-secretarias-associadas')
      .then(response => {
        if (response.status) {
          this.secretarias = response.data.data
        }
      })
      .catch(e => {
        console.log(e)
        this.$toastr.e(
          'Houve uma falha ao tentar carregar o filtro secretarias!'
        )
      })

    request
      .get('listar-autarquias-associadas')
      .then(response => {
        if (response.status) {
          this.autarquias = response.data.data
        }
      })
      .catch(e => {
        console.log(e)
        this.$toastr.e(
          'Houve uma falha ao tentar carregar o filtro autarquias!'
        )
      })
  },
  computed: {
    filtros() {
      const {
        nome,
        fonte,
        periodicidade_codigo,
        secretaria_sigla,
        autarquia_sigla,
        status_values
      } = this
      return {
        nome,
        fonte,
        periodicidade_codigo,
        secretaria_sigla,
        autarquia_sigla,
        status_values
      }
    },
    pagina: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { pagina } = dados
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dados',
          value: value
        })
      }
    },
    nome: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { nome } = dados.filtros

        return nome
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'dados',
          value: value
        })
        this.resetPageStore()
      }
    },
    fonte: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { fonte } = dados.filtros

        return fonte
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'fonte',
          collection: 'dados',
          value: value
        })
        this.resetPageStore()
      }
    },
    periodicidade_codigo: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { periodicidade_codigo } = dados.filtros

        return periodicidade_codigo
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'periodicidade_codigo',
          collection: 'dados',
          value: value
        })
        this.resetPageStore()
      }
    },
    secretaria_sigla: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { secretaria_sigla } = dados.filtros

        return secretaria_sigla
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'secretaria_sigla',
          collection: 'dados',
          value: value
        })
        this.resetPageStore()
      }
    },
    autarquia_sigla: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { autarquia_sigla } = dados.filtros

        return autarquia_sigla
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'autarquia_sigla',
          collection: 'dados',
          value: value
        })
        this.resetPageStore()
      }
    },
    status_values: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { status_values } = dados.filtros

        return status_values
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'status_values',
          collection: 'dados',
          value: value
        })
        this.resetPageStore()
      }
    }
  },
  methods: {
    titleAnos() {
      return {
        ano1: new Date().getFullYear() - 4,
        ano2: new Date().getFullYear() - 3,
        ano3: new Date().getFullYear() - 2,
        ano4: new Date().getFullYear() - 1
      }
    },
    consultar() {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      this.nome = ''
      this.fonte = ''
      this.periodicidade_codigo = '*'
      this.secretaria_codigo = ''
      this.autarquia_codigo = ''
      this.status_values = '*'
      this.$refs.vuetable.refresh()
    },
    listValues(data) {
      this.$router.push({
        name: 'admin_dado_valor_list',
        params: { DAD_IDDADO: data.codigo }
      })
    },
    editar(data) {
      this.$router.push({
        name: 'admin_dado_save',
        params: { id: data.codigo }
      })
    },
    excluir(data) {
      data.type = this.type

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .post('dado/delete', data)
            .then(response => {
              this.$toastr.s('Dado foi salvo com sucesso.')
              this.consultar()
            })
            .catch(e => {
              console.log(e)
            })
        }
      }
      this.showConfirm('Deseja realmente deletar este item?', config)
    },
    consultar() {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'dados',
        value: 1
      })
    }
  }
}
</script>

<style>
.truncate-text-70 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/dados/index.vue